<template>
  <div>
    <!--edit-->
    <button
      @click="edit(item)"
      v-if="isInclud('edit', th)"
      class="btn btn_border"
    >
      <i class="el-icon-edit-outline"></i>
    </button>
    <!--del-->
    <button @click="del(item)" v-if="isInclud('del', th)" class="btn btn_error">
      <i class="el-icon-delete"></i>
    </button>

    <!--checkbox-->
    <template>
      <el-checkbox v-if="isInclud('checkbox', th)" v-model="item['check']">
      </el-checkbox>
    </template>
    <!--Pass-->
    <button
      @click="pass(item)"
      v-if="isInclud('pass', th)"
      class="btn btn_pass">
      <i
        class="el-icon-takeaway-box"
      ></i>
    </button>

    <!--return-->
    <button
      @click="returnItem(item)"
      v-if="isInclud('return', th)"
      class="btn btn_cancel">
      <i
        class="el-icon-refresh"
      ></i>
    </button>

  </div>
</template>
<script>
export default {
  name: "table-action",
  props: {
    th: "",
    item: ""
  },
  data() {
    return {};
  },
  methods: {
      storeState(item,type){
        this.$store.commit("actionTableData", {
            item: item,
            status: true,
            type: type
        });
      },
    isInclud(item, th) {
      if (th.function.includes(item)) {
        return true;
      } else {
        return false;
      }
    },
    edit(item) {
      console.log(item,"編輯")
      this.storeState(item,'edit')
    },
    del(item) {
      console.log("table刪除", item);
      this.storeState(item,'del')
    },
    pass(item){
        this.storeState(item,'pass')
    },
    returnItem(item){
        this.storeState(item,'return')
    }
  }
};
</script>
